import Vue from 'vue';

Vue.filter('replace', (value, searchValue, newValue) => {
    return value.replace(searchValue, newValue);
});

Vue.filter('getSizeValue', value => {
    let sizeText = value.includes('$') ? value : value.includes('/') ? value.split('/')[1] : 'One Size';
    
    return sizeText;
});

Vue.filter('jsonStringify', value => {
    return JSON.stringify(value);
});